export interface LocalSystemNotification {
  title: string;
  body: string;
  /** Same tag replaces an earlier notification instead of stacking. */
  tag: string;
}

/**
 * Shows an OS-level notification without any server involvement. In the
 * Electron renderer `window.Notification` maps to native notifications; in
 * browsers it needs a previously granted permission. Never prompts: callers
 * keep their in-app surface as the primary channel.
 *
 * @returns whether a system notification was shown.
 */
export function showLocalSystemNotification(
  notification: LocalSystemNotification
): boolean {
  const NotificationApi = globalThis.Notification;
  if (!NotificationApi || NotificationApi.permission !== 'granted') {
    return false;
  }
  try {
    new NotificationApi(notification.title, {
      body: notification.body,
      tag: notification.tag,
    });
    return true;
  } catch {
    // Some platforms (e.g. Android Chrome) only allow service-worker
    // notifications; the in-app warning remains visible there.
    return false;
  }
}
